import { call } from 'api/base'

export const ProvidersApi = {
  updateAgreement(token, data) {
    return call('providers/snap/update_agreement', 'POST', token, data)
  },
  confirmation(token, data) {
    return call('providers/snap/contract', 'POST', token, data)
  },
  snapSignDocument(token, data) {
    return call('providers/snap/sign_document', 'POST', token, data)
  },
  snapCheckStatus(token, data) {
    return call('providers/snap/check_status', 'POST', token, data)
  },
  snapSendSmsLink(token, data) {
    return call('providers/snap/send_sms_link', 'POST', token, data)
  },
  active(token, data) {
    return call('providers', 'GET', token, data)
  },
  affAgreements(token) {
    return call('providers/aff_agreements', 'GET', token)
  },
  updateProgressive(token, data) {
    return call('providers/progressive/update_application', 'POST', token, data)
  },
  creditkeyAgreement(token, data) {
    return call('providers/creditkey/get_contract', 'POST', token, data)
  },
  creditkeyValidatePayment(token, data) {
    return call('providers/creditkey/validate_payment', 'POST', token, data)
  },
  progressivePrequalLookup(token, data) {
    return call('providers/progressive/prequal_lookup', 'POST', token, data)
  },
  kafeneCreateApplication(token, data) {
    return call('providers/kafene/create_application', 'POST', token, data)
  },
  kafeneCreateInvoice(token, data) {
    return call('providers/kafene/create_invoice', 'POST', token, data)
  },
  kafeneGetContract(token, data) {
    return call('providers/kafene/get_contract', 'POST', token, data)
  },
  kafeneCreateSetupIntent(token, data) {
    return call('providers/kafene/create_setup_intent', 'POST', token, data)
  },
  kafeneSignContract(token, data) {
    return call('providers/kafene/sign_contract', 'POST', token, data)
  },
  fypnAgreementPdf(token, data) {
    return call('providers/fypn/agreement_pdf', 'POST', token, data)
  },
  fypnSignAgreement(token, data) {
    return call('providers/fypn/sign_agreement', 'POST', token, data)
  },
  acimaSessionToken(token, data) {
    return call('providers/acima/session_token', 'POST', token, data)
  },
}
